module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "exam_detail_box"
  }, [_c('div', {
    staticClass: "detail_info_box"
  }, [_c('div', {
    staticClass: "detail_info_tit"
  }, [_vm._v(_vm._s(_vm.detaildata.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detaildata.content)
    }
  })]), _vm._v(" "), _c('tab-bar', {
    attrs: {
      "current-index": 0
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-44d5fcd6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/detailinfo.vue
// module id = 695
// module chunks = 1